import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/device/device.service';

@Component({
	selector: 'vtr-widget-permission-note',
	templateUrl: './widget-permission-note.component.html',
	styleUrls: ['./widget-permission-note.component.scss']
})
export class WidgetPermissionNoteComponent implements OnInit {

	@Input() noteTitle: string;
	@Input() description: string;
	@Input() path: string;
	@Input() pathText: string = this.translateService.instant('device.deviceSettings.displayCamera.camera.url');
	@Input() linkId: string;
	@Input() noPath: boolean;
	@Input() icon: string;
	@Input() noteType: string;
	@Input() linkDisabled: boolean = false;
	@Input() linkInLine: boolean = false;

	constructor(private deviceService: DeviceService, private translateService: TranslateService) { }

	ngOnInit() {
	}

	onClick(event) {
		this.deviceService.launchUri(this.path);
	}
}
